module.exports = __webpack_public_path__ + "static/media/ic_search_white_outline.02a3e8c9.svg";